<template>
  <div class="tw-text-3xl tw-font-bold tw-mb-2">
    <h3 class="tw-text-center">{{ headerText }}</h3>
  </div>
</template>

<script>
export default {
  name: "OnboardingHeader",

  props: {
    headerText: { type: String, default: () => "", required: true },
  },
};
</script>

<style lang="scss" scoped></style>
